const SITE_KEY = '6Le5UOUUAAAAAGxhyG6f5iEA2qf75SAa1BivOtZm'; // gitleaks:allow

type Action = 'downloadRoute' | 'userPaymentAction' | 'userSignupLogin' | 'editProfile';

const loadRecaptcha = (successCallback: any) => {
  const script = document.createElement('script');
  script.src = `https://www.google.com/recaptcha/api.js?render=${SITE_KEY}`;
  script.async = true;
  script.onload = () => {
    grecaptcha.ready(() => {
      successCallback(grecaptcha);
    });
  };
  document.body.appendChild(script);
};

// see https://developers.google.com/recaptcha/docs/v3
const execute = (recaptchaObject: any, action: Action) => recaptchaObject.execute(SITE_KEY, { action });

async function executeRecaptcha(action: Action) {
  return new Promise<string>(resolve => {
    loadRecaptcha((recaptchaObject: any) => {
      execute(recaptchaObject, action).then((token: string) => resolve(token));
    });
  });
}

export { executeRecaptcha };
